<!-- Zweck: Stellt die HTML-Struktur für app warenkorb menu component im Frontend bereit. -->
<div style="display: inline-block; position: relative">
  @if (lieferkunde) {
    <button (mouseenter)="show()" (mouseleave)="hide()"
      class="warenkorb-menu-cart-button tut_navbar_wkbutton"
      mat-button
      routerLink="{{warenkorb_link}}">
      <span class="warenkorb-menu-icon" [class.add-feedback]="addFeedbackActive"
        [class.arrival-feedback]="arrivalFeedbackActive">
        <svg-icon matBadge="{{article_count}}" matBadgeSize="large">warenkorb</svg-icon>
        <span class="warenkorb-menu-item" aria-hidden="true"></span>
      </span>
    </button>
  }
  @if (warenkoerbe) {
    <div (mouseenter)="show2()" (mouseleave)="hide2()" [class.hidden]="!open && !open2"
      class="menu mat-elevation-z1" [class.mobile]="msvc.isMobile()|async">
      <table>
        <tr>
          <th></th>
          @if (warenkoerbe.length > 1) {
            <th style="text-align: left">Bezeichnung</th>
          }
          <th style="padding: 2px">Positionen</th>
          <th style="padding: 2px">Einkaufswert</th>
        </tr>
        @for (wk of warenkoerbe; track wk; let first = $first; let last = $last) {
          <tr (click)="navigateTo('/shop/warenkorb/'+wk.id)"
            class="buttontr" [class.default]="!last && !first" [class.last]="last" [class.first]="first">
            <td>
              @if (primary_warenkorb && primary_warenkorb.id == wk.id) {
                <svg-icon matTooltip="Haupt-Warenkorb"
                  style="font-size: 12px; height: 12px">radiobutton-gefuellt
                </svg-icon>
              }
              @if (primary_warenkorb && primary_warenkorb.id != wk.id) {
                <svg-icon style="font-size: 12px; height: 12px">
                  radiobutton-leer
                </svg-icon>
              }
            </td>
            @if (warenkoerbe.length > 1) {
              <td style="text-align: left">
                {{wk.label}}
              </td>
            }
            <td>
              {{wk.artikel_count}}
            </td>
            <td style="text-align: right">
              {{wk.wert_summe|NiceNumber}} &euro;
            </td>
          </tr>
        }
      </table>
      <a routerLink="/shop/warenkorb">Zu den Warenkörben</a>
    </div>
  }
</div>
